// Module
var code = `<template>
  <require from="./portfolio-by-type-widget.scss"></require>

  <div class="portfolio-by-type-widget">
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <!-- chart slightly sticks out from its boundaries, 97% makes sure there's no scroll -->
    <div show.bind="!loading && !error" class="portfolio-by-type-widget__chart" style="height: 97%" element.ref="chart">
    </div>
    <message if.bind="error" icon="error" colour="mdc-theme--error" class="portfolio-by-type-widget__error">
      \${error.message}</message>
  </div>
</template>
`;
// Exports
export default code;